// @flow
import React, { Component } from 'react';
import { Table } from 'reactstrap';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';

import RolesDropdown from './RolesDropdown';
import SearchBar from './SearchBar';
import UserInfo from './UserInfo';

import api from '../../../lib/api';
import endpoints from '../../../lib/endpoints';

import { UsersContext } from './UsersContext';
import Loading from '../../../components/Loading';

type User = {
  fullname: string,
  roles: null | Array<string>,
  email: null | string,
  id: string,
};

type State = {
  searchTerm: string,
  users: Array<User>,
  filters: {
    role: string,
  },
  errors: string,
};

type Props = {};

class UsersPanel extends Component<Props, State> {
  state = {
    searchTerm: '',
    users: [],
    filters: {
      role: '',
    },
    errors: '',
  };

  render() {
    return (
      <div className="container">
        <div className="white-panel admin-dash">
          <UsersContext.Provider value={{ updateUser: this.updateUserInfo }}>
            <h2>Users Panel</h2>
            <span>
              <SearchBar onChange={this.handleSearchTermChange} />
            </span>
            <Table striped>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email / Name</th>
                  <th>User ID</th>
                  <th>
                    <RolesDropdown onChange={this.handleRoleDropdownChange} />
                  </th>
                  <th colSpan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.users.length > 0 ? this.renderUsers(this.state.users) : null}
              </tbody>
            </Table>
            {/* RENDER LOADING IF THERE ARE NOT USERS */}
            {this.state.users.length > 0 ? null : (
              <div className="row">
                <div className="col">
                  <Loading size="small" />
                </div>
              </div>
            )}
          </UsersContext.Provider>
        </div>
      </div>
    );
  }

  handleSearchTermChange = (val: string) => {
    this.setState({ searchTerm: val.toLowerCase() });
  };

  handleRoleDropdownChange = (val: string) => {
    this.setState(state => ({
      filters: { ...state.filter, role: val.toLowerCase() },
    }));
  };

  renderUsers = (users: Array<User>) => {
    const filteredUsers = this.getFilteredUsers(users);
    const sortedUsers = sortBy(filteredUsers, ['email', 'fullname']);

    return sortedUsers.map((user, index) => {
      return <UserInfo key={user.id} {...user} index={index} />;
    });
  };

  getFilteredUsers = (users: Array<User>) => {
    const { searchTerm, filters } = this.state;
    const { role } = filters;
    // FILTER USERS BY ROLE
    users =
      role !== ''
        ? users.filter(
            user =>
              user.roles &&
              user.roles
                .join(' ')
                .toLowerCase()
                .includes(role)
          )
        : users;

    // FILTER USERS BY EMAIL AND FULLNAME
    const filteredUsers =
      searchTerm !== ''
        ? filter(users, user => {
            const email = user.email ? user.email.toLowerCase() : '';
            const name = user.fullname ? user.fullname.toLowerCase() : '';
            const userId = user.id ? user.id.toLowerCase() : '';
            // FILTER BY EMAIL, FULLNAME, USER ID
            return (
              email.indexOf(searchTerm) >= 0 ||
              name.indexOf(searchTerm) >= 0 ||
              userId.indexOf(searchTerm) >= 0
            );
          })
        : users;

    return filteredUsers;
  };

  updateUserInfo = (updatedUserInfo: User) => {
    const userId = updatedUserInfo.id;
    const userIndex = this.getUserIndexById(userId);

    if (userIndex) {
      this.setState(state => {
        const { users } = state;
        users[userIndex] = {
          ...users[userIndex],
          ...updatedUserInfo,
        };
        return { users };
      });
    }
  };

  getUserIndexById = id => {
    const { users } = this.state;
    let userIndex;
    users.map((user, index) => {
      if (user.id === id) userIndex = index;
      return null;
    });
    return userIndex;
  };

  async componentDidMount() {
    try {
      const { data } = await api.getWithToken(endpoints.admin.getUsers());
      this.setState({
        users: data,
      });
    } catch (e) {
      this.setState({ error: 'Couldn\'t Fetch Users.' });
    }
  }
}

export default UsersPanel;



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/UsersPanel.jsx